var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOverviewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 2C0.25 1.0335 1.0335 0.25 2 0.25H16C16.9665 0.25 17.75 1.0335 17.75 2V18C17.75 18.9665 16.9665 19.75 16 19.75H2C1.0335 19.75 0.25 18.9665 0.25 18V2ZM2 1.75C1.86193 1.75 1.75 1.86193 1.75 2V18C1.75 18.1381 1.86193 18.25 2 18.25H16C16.1381 18.25 16.25 18.1381 16.25 18V2C16.25 1.86193 16.1381 1.75 16 1.75H2ZM14.5 14.75H6.5V13.25H14.5V14.75ZM6.5 10.75H14.5V9.25H6.5V10.75ZM14.5 6.75H6.5V5.25H14.5V6.75ZM4.5 14.75C4.91421 14.75 5.25 14.4142 5.25 14C5.25 13.5858 4.91421 13.25 4.5 13.25C4.08579 13.25 3.75 13.5858 3.75 14C3.75 14.4142 4.08579 14.75 4.5 14.75ZM5.25 10C5.25 10.4142 4.91421 10.75 4.5 10.75C4.08579 10.75 3.75 10.4142 3.75 10C3.75 9.58579 4.08579 9.25 4.5 9.25C4.91421 9.25 5.25 9.58579 5.25 10ZM4.5 6.75C4.91421 6.75 5.25 6.41421 5.25 6C5.25 5.58579 4.91421 5.25 4.5 5.25C4.08579 5.25 3.75 5.58579 3.75 6C3.75 6.41421 4.08579 6.75 4.5 6.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewIcon);
export default __webpack_public_path__ + "static/media/overview-icon.6cf8633cd1974e80a305e345031f9367.svg";
export { ForwardRef as ReactComponent };